import { cn } from "@/lib/utils";
import EllipsisTooltip from "@component/tooltip/EllipsisTooltip";
import { Ellipsis, X } from "lucide-react";
import React from "react";

const Chip = ({
  list = [],
  displayKey = "",
  uniqueKey = "",
  onDelete = () => null,
  className = "",
  hideRemoveButton = false,
  containerClassName = "",
  needEllipsis = false,
}) => {
  return (
    <div className={cn("flex flex-wrap gap-2", containerClassName)}>
      {list.map((item, i) => (
        <div
          key={uniqueKey ? item?.[uniqueKey] : i}
          className={cn(
            "flex items-center gap-1 px-2 py-1 rounded-full text-sm border dark:border-none bg-gray-100 text-gray-800 dark:bg-gray-600 dark:text-form-label",
            className
          )}
        >
          {needEllipsis ? <EllipsisTooltip>{displayKey ? item?.[displayKey] : item}</EllipsisTooltip>:
          <span>{displayKey ? item?.[displayKey] : item}</span>}
          {!hideRemoveButton && (
            <button
              type="button"
              onClick={(e) => onDelete(item, i)}
              className="ml-1 hover:text-red-500"
            >
              <X size={14} className="shrink-0" />
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default Chip;
